module.exports = __webpack_public_path__ + "static/media/Logo.4decfec5.svg";